module.exports = __webpack_public_path__ + "img/login-dark.416a2c75.svg";